import axios from 'axios'
import router from '../router/routes'
import store from '../store'

const instance = axios.create({
    baseURL: process.env.VUE_APP_API_HOST,
    headers: {
        common: {
            Authorization: '',
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    }
})

instance.interceptors.response.use(response => {
    return response
}, error => {
    let errorResponse = {
        code: 0,
        message: '',
        data: error.response.data || []
    }

    const errorCode = error.response.status

    errorResponse.code = errorCode

    switch (errorCode) {
        case 400:
        case 409:
            let message = []
            for (let errorGroup in errorResponse.data) {
                message.push(errorResponse.data[errorGroup].join('<br />'))
            }
            errorResponse.message = message.join('<br />')
            break
        case 401:
            window.oidc.userManager.signoutRedirect()
            break
        case 500:
            errorResponse.message = 'Internal server error. Please contact with administrator.'
            break
        default:
            errorResponse.message = error.toString()
    }

    return Promise.reject(errorResponse)
})

export default instance
